import { MdOutlinePersonAddAlt, MdAddCircleOutline } from "react-icons/md";
import { ContactListType } from "utils/interfaces";
import UserCardForm from "../../cards/UserFormCard";

interface AddContactProps {
  selectedContacts: ContactListType[];
  handleClickAddContacts: () => void;
  setSelectedContacts: React.Dispatch<React.SetStateAction<ContactListType[]>>;
  setSelectedData: React.Dispatch<React.SetStateAction<ContactListType | null>>;
  setShowEditContact: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddContact: React.FC<AddContactProps> = ({
  selectedContacts,
  handleClickAddContacts,
  setSelectedContacts,
  setSelectedData,
  setShowEditContact,
}) => {
  /**
   * Function used to operate on click of the delete button
   */
  const handleDeleteContact = (contact: ContactListType) => {
    // Deleting the contact with the current id
    const contactsFiltered = selectedContacts.filter(
      (currentContact: ContactListType) => currentContact._id !== contact._id
    );
    if (setSelectedContacts) setSelectedContacts(contactsFiltered);
  };

  /**
   * Function used to operate on click of the edit/open button
   */
  const handleEditContact = (contact: ContactListType) => {
    // Deleting the contact with the current id
    if (setSelectedData && setShowEditContact) {
      // Select the current data
      setSelectedData(contact);
      // And display the pop up
      setShowEditContact(true);
    }
  };

  return (
    <div className="self-stretch h-fit flex-col justify-start items-start gap-12 flex">
      <div className="self-stretch h-fit flex-col justify-start items-start gap-1.5 flex">
        <div className="justify-start text-neutral-500 text-xs font-normal font-sans uppercase leading-none tracking-wide">
          Contact Details*
        </div>
        {selectedContacts.length === 0 ? (
          <button
            className="w-full px-2 py-3 rounded-lg border border-dashed border-neutral-300 hover:bg-neutral-25 ease-in-out duration-150 justify-center items-center gap-2 inline-flex cursor-pointer"
            onClick={handleClickAddContacts}
          >
            <div className="w-6 h-6 relative">
              <MdOutlinePersonAddAlt className="w-full h-full fill-neutral-500" />
            </div>
            <div className="text-neutral-500 text-base font-normal font-sans leading-[19px]">
              Add a contact
            </div>
          </button>
        ) : (
          <>
            {selectedContacts.length > 0 &&
              selectedContacts.map(
                (contact: ContactListType, index: number) => (
                  <UserCardForm
                    key={index}
                    user={contact}
                    selectedUsers={selectedContacts}
                    primaryTag={true}
                    handleDelete={handleDeleteContact}
                    handleEdit={handleEditContact}
                  />
                )
              )}
            <div
              className="group rounded justify-center items-center gap-2 flex cursor-pointer"
              onClick={handleClickAddContacts}
            >
              <div className="w-6 h-6 relative">
                <MdAddCircleOutline className="w-full h-full fill-secondary-600 group-hover:fill-secondary-700" />
              </div>
              <div className="text-secondary-600 group-hover:text-secondary-700 text-lg font-semibold font-sans leading-snug">
                Add additional contact
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddContact;
